import { GUI } from 'dat.gui'
import { BlendFunction, DepthOfFieldEffect } from 'postprocessing'
import { DepthOfFieldDto } from '../../../../../trillion-common/src/dto/posteffects/depth-of-field.dto'

import { DepthOfField } from '../../../../../trillion-common/src/objects/posteffects/depth-of-field.object'
import { StoreScheme } from '../../../shared/store/store'

export function addDepthOfFieldGUI(
  gui: GUI,
  depthOfFieldEffect: DepthOfFieldEffect,
  depthOfFieldConfig: DepthOfFieldDto | undefined,
  store: StoreScheme,
) {
  const setDepthOfField = store.getState().setDepthOfField

  const blendMode = depthOfFieldEffect.blendMode
  const circleOfConfusionMaterial = depthOfFieldEffect.circleOfConfusionMaterial
  const resolution = depthOfFieldEffect.resolution

  const depthOfFieldOptions = {
    blendFunction: blendMode.blendFunction,
    bokehScale: depthOfFieldEffect.bokehScale,

    focusDistance: depthOfFieldConfig?.focusDistance ?? circleOfConfusionMaterial.focusDistance,
    focalLength: depthOfFieldConfig?.focalLength ?? circleOfConfusionMaterial.focalLength,
    focusRange: depthOfFieldConfig?.focusRange ?? circleOfConfusionMaterial.focusRange,
    worldFocusDistance: circleOfConfusionMaterial.worldFocusDistance,
    worldFocusRange: circleOfConfusionMaterial.worldFocusRange,

    resolutionScale: resolution.scale,
    opacity: depthOfFieldConfig?.opacity ?? (blendMode.opacity.value as number),
  }

  const depthOfFieldFolder = gui.addFolder(`Depth of Field`)
  depthOfFieldFolder.close()

  depthOfFieldFolder
    .add(depthOfFieldOptions, 'blendFunction', BlendFunction)
    .name('blend mode')
    .onChange((value) => {
      const numValue = Number(value)
      depthOfFieldEffect.blendMode.blendFunction = numValue
      updateDepthOfFieldEffect((depthOfField) => {
        depthOfField.blendFunction = numValue
      })
    })
  depthOfFieldFolder
    .add(depthOfFieldOptions, 'bokehScale', 0.0, 30.0, 0.1)
    .name('bokeh scale')
    .onChange((value: number) => {
      depthOfFieldEffect.bokehScale = value
      updateDepthOfFieldEffect((depthOfField) => {
        depthOfField.bokehScale = value
      })
    })

  depthOfFieldFolder
    .add(depthOfFieldOptions, 'focusDistance', 0.0, 1.0, 0.001)
    .name('focus distance')
    .onChange((value: number) => {
      depthOfFieldEffect.circleOfConfusionMaterial.focusDistance = value
      updateDepthOfFieldEffect((depthOfField) => {
        depthOfField.focusDistance = value
      })
    })
  depthOfFieldFolder
    .add(depthOfFieldOptions, 'focalLength', 0.0, 1.0, 0.001)
    .name('focal length')
    .onChange((value: number) => {
      depthOfFieldEffect.circleOfConfusionMaterial.focalLength = value
      updateDepthOfFieldEffect((depthOfField) => {
        depthOfField.focalLength = value
      })
    })
  depthOfFieldFolder
    .add(depthOfFieldOptions, 'focusRange', 0.0, 1.0, 0.001)
    .name('focus range')
    .onChange((value: number) => {
      depthOfFieldEffect.circleOfConfusionMaterial.focusRange = value
      updateDepthOfFieldEffect((depthOfField) => {
        depthOfField.focusRange = value
      })
    })
  depthOfFieldFolder
    .add(depthOfFieldOptions, 'worldFocusDistance', 0.0, 50.0, 0.1)
    .name('w.focus distance')
    .onChange((value: number) => {
      depthOfFieldEffect.circleOfConfusionMaterial.worldFocusDistance = value
      updateDepthOfFieldEffect((depthOfField) => {
        depthOfField.worldFocusDistance = value
      })
    })
  depthOfFieldFolder
    .add(depthOfFieldOptions, 'worldFocusRange', 0.0, 50.0, 0.1)
    .name('w.focus range')
    .onChange((value: number) => {
      depthOfFieldEffect.circleOfConfusionMaterial.worldFocusRange = value
      updateDepthOfFieldEffect((depthOfField) => {
        depthOfField.worldFocusRange = value
      })
    })

  depthOfFieldFolder
    .add(depthOfFieldOptions, 'resolutionScale', 0.01, 1.0, 0.01)
    .name('resolution scale')
    .onChange((value: number) => {
      depthOfFieldEffect.resolution.scale = value
      updateDepthOfFieldEffect((depthOfField) => {
        depthOfField.resolutionScale = value
      })
    })
  depthOfFieldFolder
    .add(depthOfFieldOptions, 'opacity', 0.0, 1.0, 0.01)
    .name('opacity')
    .onChange((value: number) => {
      depthOfFieldEffect.blendMode.opacity.value = value
      updateDepthOfFieldEffect((depthOfField) => {
        depthOfField.opacity = value
      })
    })

  function updateDepthOfFieldEffect(updateCallback: (depthOfField: DepthOfField) => void) {
    updateCallback(depthOfFieldOptions)
    setDepthOfField(depthOfFieldOptions)
  }

  setDepthOfField(depthOfFieldOptions)
}
